
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AvailableService } from '@/features/shipment/types';
import { getDeliveryDateAndTime } from '@/features/common/helpers';
import { getCutoffTime } from '@/features/shipment/helpers/createShipment';
import ShippingAddress from '../ShippingAddress.vue';
import PackagesDetail from '../PackagesDetail.vue';
import EstimateCostBreakdown from '../EstimateCostBreakdown.vue';

@Component({
  components: {
    ShippingAddress,
    PackagesDetail,
    EstimateCostBreakdown,
  },
})
export default class Details extends Vue {
  @Prop({ required: true }) service!: AvailableService;

  get deliveryDateAndTime(): { date: string, time: string } {
    return getDeliveryDateAndTime(this.service.deliveryTime);
  }

  private getCutoffTime = getCutoffTime;
}
